var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.data.username !== this.user.username
    ? _c("div", { staticStyle: { display: "inline-block" } }, [
        _c(
          "div",
          { staticClass: "d-flex pr-05", class: "friend-actions-" + this._uid },
          [
            _vm.isLoading
              ? _c(
                  "div",
                  {
                    staticClass:
                      "spinner-border spinner-border-sm text-primary",
                    attrs: { role: "status" },
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("Loading..."),
                    ]),
                  ]
                )
              : _c(
                  "div",
                  [
                    _vm.contactStatus === false
                      ? _c(
                          "button",
                          {
                            class:
                              "btn btn-success waves-effect waves-light " +
                              _vm.size,
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.follow()
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.__("globals.follow")) +
                                  " " +
                                  _vm._s(
                                    _vm.size === "btn-sm"
                                      ? ""
                                      : _vm.data.first_name
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("i", { staticClass: "feather icon-user-plus" }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.contactStatus === true
                      ? _c(
                          "button",
                          {
                            class:
                              "btn btn-danger waves-effect waves-light " +
                              _vm.size,
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.unfollow()
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.__("globals.unfollow")) +
                                  " " +
                                  _vm._s(
                                    _vm.size === "btn-sm"
                                      ? ""
                                      : _vm.data.first_name
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "feather icon-user-minus ",
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.contactStatus === "pendingRequest"
                      ? _c(
                          "button",
                          {
                            class:
                              "btn btn-primary waves-effect waves-light " +
                              _vm.size,
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.cancelPending()
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.size === "btn-sm"
                                      ? _vm.__("globals.pending")
                                      : _vm.__(
                                          "globals.pending_contact_request"
                                        )
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("i", { staticClass: "feather icon-time" }),
                          ]
                        )
                      : _vm.contactStatus === "pendingAccept" &&
                        !this.hideButtons
                      ? [
                          _c(
                            "button",
                            {
                              class:
                                "btn btn-success waves-effect waves-light " +
                                _vm.size,
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.acceptRequest()
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.size === "btn-sm"
                                        ? _vm.__("globals.accept")
                                        : _vm.__(
                                            "globals.accept_contact_request"
                                          )
                                    ) +
                                    "\n                    "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              class:
                                "btn btn-danger waves-effect waves-light " +
                                _vm.size,
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.declineRequest()
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.size === "btn-sm"
                                        ? _vm.__("globals.decline")
                                        : _vm.__(
                                            "globals.decline_contact_request"
                                          )
                                    ) +
                                    "\n                    "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }